import { getUser } from "$lib/userstorage/usersotrage"
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD=="si";
let RUTA_JAVA =bd_local? ruta_local_java:ruta_java;
const RUTA_ESTABLECIMIENTOS = "establishments"


function processColabos(colabs){
    let data_colabs = []
    for(let i = 0;i<colabs.length;i++){
        let fila = colabs[i]
       
        let data = {
            id:fila.userId,
            correo:fila.email,
            nombre:fila.firstName,
            apellido:fila.lastName
        }
        data_colabs.push(data)
    }
    return data_colabs
}
export function processEstablishment(establishment) {
    let data_est = {
        id: establishment.establishmentId,
        nombre: establishment.name,
        direccion: establishment.address,
        contacto: establishment.contactReference,
        codigo: "",
        renspa: establishment.renspaCode,
        provincia: establishment.province,
        localidad: establishment.city,

        telefono: establishment.phone,
        mail: establishment.email,
        titular: establishment.ownerName,
        latitud: establishment.latitude ?? null,
        longitud: establishment.longitude ?? null,
        active: establishment.isActive,
        // El DTO trae los ids de animales del establecimiento; nos
        // quedamos solo con el conteo para mostrarlo en las tarjetas.
        totalAnimales: Array.isArray(establishment.animalIds) ? establishment.animalIds.length : 0,
        colaboradores:processColabos(establishment.users)


    }
    return data_est
}
export function processEstablishments(data) {
    let data_ests = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        let est = processEstablishment(fila)
        if (est.active) {
            data_ests.push(est)
        }

    }
    return data_ests
}
export async function getAll() {
    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/all`
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await handleAuthenticatedRequest(ruta, options)
    // Sin este chequeo un 500/502 se veia como "no tenes establecimientos".
    let data_all = await jsonOrThrow(res_all, "getAll establecimientos")

    let procesada = processEstablishments(data_all)

    return procesada

}
// --- Cache offline de la cuenta (localStorage) ---
// getAllColabs alimenta los totales de /user/config y el listado de
// /establecimientos; offline el fetch tira y quedaban vacios. Guardamos la
// ultima respuesta procesada y la servimos sin red, sin enmascarar 401/403
// reales (esos se propagan). Mismo criterio que permisosback.js.
const COLABS_CACHE_PREFIX = "cf_colabs_";
function readColabsCache(id) {
    try {
        const raw = localStorage.getItem(COLABS_CACHE_PREFIX + id);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}
function writeColabsCache(id, value) {
    try {
        localStorage.setItem(COLABS_CACHE_PREFIX + id, JSON.stringify(value));
    } catch (e) {
        // storage lleno/no disponible: el cache es best-effort
    }
}
// `.status` numérico = el servidor CONTESTÓ con un error (4xx/5xx, via
// jsonOrThrow): propagarlo. Servir cache ahí escondería la falla real.
function isRealAuthError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number");
}

export async function getAllColabs(){
    let user = getUser();
    let token = user.token;
    let id = user.id

    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/user/${id}`
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await handleAuthenticatedRequest(ruta, options)
        let data_all = await jsonOrThrow(res_all, "establecimientos.getAllColabs")
        let procesada = processEstablishments(data_all)
        writeColabsCache(id, procesada)
        return procesada
    } catch (err) {
        if (isRealAuthError(err)) throw err
        // Red caida (offline): servir la ultima cuenta conocida si existe.
        const cached = readColabsCache(id)
        if (cached) return cached
        throw err
    }
}
// `token` opcional: si se pasa, se usa ese access (scoped a un establecimiento
// que no es el activo, para el prefetch multi-establecimiento). Sin token usa el
// de la sesión activa. Hace un fetch crudo a propósito: offline rechaza y el
// caller (getCabaña) cae al detalle cacheado en TanStack.
export async function getEstablishmentId(id, token) {
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${id}`
    let t = token ?? getUser().token;
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${t}`
        }
    }
    let res_all = await fetch(ruta, options)
    let data_all = await res_all.json()

    let procesada = processEstablishment(data_all)
    return procesada
}
function postData(data) {
    let data_est = {
        name: data.nombre,
        address: data.direccion,
        contactReference: data.contacto,
        renspaCode: data.renspa
    }
    return data_est
}
function updateData(data) {
    let data_est = {
        name: data.nombre,
        address: data.direccion,
        contactReference: data.contacto,
        renspaCode: data.renspa,
        province: data.provincia,
        city: data.localidad,
        phone: data.telefono,
        email: data.mail,
        latitude: data.latitud ? parseFloat(data.latitud) : null,
        longitude: data.longitud ? parseFloat(data.longitud) : null,
    }

    return data_est
}
export async function saveEstablishment(data) {
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}`
    let data_est = postData(data)
    let user = getUser();
    let token = user.token;
    data_est.email = user.useremail
    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: JSON.stringify(data_est),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUser().token}`
        },
    })
    if (!res_save.ok) {
        let mensaje = `saveEstablishment -> ${res_save.status}`
        let code
        try {
            const body = await res_save.json()
            if (body && body.message) mensaje = body.message
            // "PLAN_LIMIT_REACHED" cuando ya llegó al tope de campos de su plan.
            code = body?.code
        } catch (_) { /* respuesta sin cuerpo JSON */ }
        const err = new Error(mensaje)
        err.status = res_save.status
        err.code = code
        throw err
    }
    return await res_save.json()
}
export async function addColabEstablishment(data,cabid) {
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${cabid}/collaborators`
    let user = getUser();
    let token = user.token;
    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
}
export async function updateEstablishment(data, id) {
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${id}`
    let data_est = updateData(data)
    let user = getUser();
    let token = user.token;
    let res_save = await fetch(ruta, {
        method: "PUT",
        body: JSON.stringify(data_est),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    // Sin este chequeo el body de error del back (403/4xx, que tambien es
    // JSON) se parseaba como si fuera el establecimiento actualizado y el
    // caller lo tomaba por exito. Mismo patron que el resto de los *back.js:
    // Error con `.status` para que la pantalla distinga "no autorizado".
    if (!res_save.ok) {
        let mensaje = `updateEstablishment -> ${res_save.status}`
        try {
            const body = await res_save.json()
            if (body && body.message) mensaje = body.message
        } catch (_) { /* respuesta sin cuerpo JSON */ }
        const err = new Error(mensaje)
        err.status = res_save.status
        throw err
    }
    let data_save = await res_save.json()
    return data_save

}
export async function deleteEstablishment(id) {
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/delete/${id}`
    let user = getUser();
    let token = user.token;
    let res_save = await fetch(ruta, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`
        },
    })
    if (!res_save.ok) {
        throw new Error(`deleteEstablishment -> ${res_save.status}`)
    }
}
function processColaborador(fila){
    let data = {
        id:fila.userId,
        nombre:fila.firstName,
        apellido:fila.lastName
    }
    return data
}
function processColaboradores(data){
    let filas = []
    for(let i = 0;i<data.length;i++){
        filas.push(processColaborador(data[i]))
    }
    return filas

}
export async function getColaboradores(id){
    let user = getUser();
    let token = user.token;
    

    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${id}/collaborators`
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await handleAuthenticatedRequest(ruta, options)
    let data_all = await jsonOrThrow(res_all, "establecimientos.getColaboradores")

    let procesada = processColaboradores(data_all)
    
    return procesada
}
export async function setDueñoEstablecimiento(establecimientoid){
    if (!establecimientoid) {
        throw new Error("setDueñoEstablecimiento: establecimientoid vacio")
    }
    let user = getUser();
    let token = user.token;
    let usuarioid = user.id
    if (!usuarioid) {
        throw new Error("setDueñoEstablecimiento: getUser().id vacio")
    }
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/user/${usuarioid}`
    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`
        },
    })
    if (!res_save.ok) {
        throw new Error(`setDueñoEstablecimiento -> ${res_save.status}`)
    }
}

export async function addEmailColabEstablishment(data,cabid) {

    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${cabid}/collaborators`
    let user = getUser();
    let token = user.token;
    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    if (!res_save.ok) {
        let body_error = await res_save.json().catch(() => ({}));
        const err = new Error(body_error.message || `Error ${res_save.status}`)
        // `.status` para que la pantalla decida el texto en vez de mostrar el del
        // backend crudo. Mismo patron que el resto de los *back.js.
        err.status = res_save.status
        // "PLAN_LIMIT_REACHED" cuando el establecimiento llegó al tope de
        // colaboradores del plan del titular.
        err.code = body_error.code
        throw err
    }
}

export async function addNewColabEstablecimiento(establecimientoid, useruid, roleId){
    if (!establecimientoid) {
        throw new Error("addColabEstablecimiento: establecimientoid vacio")
    }

    if (!useruid) {
        throw new Error("addColabEstablecimiento: getUser().id vacio")
    }
    let user = getUser();
    let token = user.token;
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/user/${useruid}`
    if (roleId) ruta += `?roleId=${roleId}`
    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`
        },
    })
    if (!res_save.ok) {
        let body_error = await res_save.json().catch(() => ({}));
        const err = new Error(body_error.message || `Error ${res_save.status}`)
        err.status = res_save.status
        // "PLAN_LIMIT_REACHED" cuando el establecimiento llegó al tope de
        // colaboradores del plan del titular (addUserToEstablishment →
        // checkUserLimit). Sin esto, mensajeLimitePlan no podía distinguirlo de
        // un error cualquiera y la pantalla mostraba "intentá de nuevo" para algo
        // que reintentar no arregla.
        err.code = body_error.code
        throw err
    }
}
export async function quitarColabEstablecimiento(establecimientoid,useruid){
    if (!establecimientoid) {
        throw new Error("quitarColabEstablecimiento: establecimientoid vacio")
    }

    if (!useruid) {
        throw new Error("quitarColabEstablecimiento: getUser().id vacio")
    }
    let user = getUser();
    let token = user.token;
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/user/${useruid}`
    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "DELETE",
        headers: {
            "Authorization": `Bearer ${token}`
        },
    })
    if (!res_save.ok) {
        throw new Error(`set colaborador -> ${res_save.status}`)
    }
}
export async function confirmInvitation(token) {
    let ruta = `${RUTA_JAVA}activation/confirm?token=${encodeURIComponent(token)}`
    let res = await fetch(ruta)
    let data = await res.json().catch(() => ({}))
    if (!res.ok) {
        const err = new Error(data.message || `Error ${res.status}`)
        err.status = res.status
        throw err
    }
    return data
}
export async function importarAnimales(establecimientoid,archivo){
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/import-animal`
    
    const formData = new FormData();
    formData.append("file", archivo); // Debe coincidir con @RequestParam("file")
    let user = getUser();
    let token = user.token;
    

    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: formData,
        headers: {
            "Authorization": `Bearer ${user.token}`
        },
    })
    if (!res_save.ok) {
        let msg = `Error ${res_save.status}`;
        let code;
        try {
            const body = await res_save.json();
            msg = body.message ?? body.error ?? msg;
            // "PLAN_LIMIT_REACHED" cuando el lote no entra en el cupo del plan.
            code = body.code;
        } catch (_) {}
        const err = new Error(msg);
        // El servidor respondió y rechazó el archivo (p. ej. planilla de otra entidad).
        // Distinto de un fallo de red, donde no hay mensaje que valga la pena mostrar.
        err.esRespuestaDelBackend = true;
        err.status = res_save.status;
        err.code = code;
        throw err;
    }
    return await res_save.json()
}
export async function importarLotes(establecimientoid,archivo){
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/import-lotes`
    
    const formData = new FormData();
    formData.append("file", archivo); // Debe coincidir con @RequestParam("file")
    let user = getUser();
    let token = user.token;
    

    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: formData,
        headers: {
            "Authorization": `Bearer ${user.token}`
        },
    })
    if (!res_save.ok) {
        let msg = `Error ${res_save.status}`;
        let code;
        try {
            const body = await res_save.json();
            msg = body.message ?? body.error ?? msg;
            // "PLAN_LIMIT_REACHED" cuando el lote no entra en el cupo del plan.
            code = body.code;
        } catch (_) {}
        const err = new Error(msg);
        // El servidor respondió y rechazó el archivo (p. ej. planilla de otra entidad).
        // Distinto de un fallo de red, donde no hay mensaje que valga la pena mostrar.
        err.esRespuestaDelBackend = true;
        err.status = res_save.status;
        err.code = code;
        throw err;
    }
    return await res_save.json()
}
export async function importarRodeos(establecimientoid,archivo){
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/import-rodeos`
    
    const formData = new FormData();
    formData.append("file", archivo); // Debe coincidir con @RequestParam("file")
    let user = getUser();
    let token = user.token;
    

    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: formData,
        headers: {
            "Authorization": `Bearer ${user.token}`
        },
    })
    if (!res_save.ok) {
        let msg = `Error ${res_save.status}`;
        let code;
        try {
            const body = await res_save.json();
            msg = body.message ?? body.error ?? msg;
            // "PLAN_LIMIT_REACHED" cuando el lote no entra en el cupo del plan.
            code = body.code;
        } catch (_) {}
        const err = new Error(msg);
        // El servidor respondió y rechazó el archivo (p. ej. planilla de otra entidad).
        // Distinto de un fallo de red, donde no hay mensaje que valga la pena mostrar.
        err.esRespuestaDelBackend = true;
        err.status = res_save.status;
        err.code = code;
        throw err;
    }
    return await res_save.json()
}
export async function importarServicios(establecimientoid,archivo){
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/import-servicios`
    
    const formData = new FormData();
    formData.append("file", archivo); // Debe coincidir con @RequestParam("file")
    let user = getUser();
    let token = user.token;
    

    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: formData,
        headers: {
            "Authorization": `Bearer ${user.token}`
        },
    })
    if (!res_save.ok) {
        let msg = `Error ${res_save.status}`;
        let code;
        try {
            const body = await res_save.json();
            msg = body.message ?? body.error ?? msg;
            // "PLAN_LIMIT_REACHED" cuando el lote no entra en el cupo del plan.
            code = body.code;
        } catch (_) {}
        const err = new Error(msg);
        // El servidor respondió y rechazó el archivo (p. ej. planilla de otra entidad).
        // Distinto de un fallo de red, donde no hay mensaje que valga la pena mostrar.
        err.esRespuestaDelBackend = true;
        err.status = res_save.status;
        err.code = code;
        throw err;
    }
    return await res_save.json()
}
export async function importarObservaciones(establecimientoid,archivo){
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/import-observaciones  `
    
    const formData = new FormData();
    formData.append("file", archivo); // Debe coincidir con @RequestParam("file")
    let user = getUser();
    let token = user.token;
    

    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: formData,
        headers: {
            "Authorization": `Bearer ${user.token}`
        },
    })
    if (!res_save.ok) {
        let msg = `Error ${res_save.status}`;
        let code;
        try {
            const body = await res_save.json();
            msg = body.message ?? body.error ?? msg;
            // "PLAN_LIMIT_REACHED" cuando el lote no entra en el cupo del plan.
            code = body.code;
        } catch (_) {}
        const err = new Error(msg);
        // El servidor respondió y rechazó el archivo (p. ej. planilla de otra entidad).
        // Distinto de un fallo de red, donde no hay mensaje que valga la pena mostrar.
        err.esRespuestaDelBackend = true;
        err.status = res_save.status;
        err.code = code;
        throw err;
    }
    return await res_save.json()
}
export async function importarPesajes(establecimientoid,archivo){
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/import-pesajes`
    
    const formData = new FormData();
    formData.append("file", archivo); // Debe coincidir con @RequestParam("file")
    let user = getUser();
    let token = user.token;
    

    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: formData,
        headers: {
            "Authorization": `Bearer ${user.token}`
        },
    })
    if (!res_save.ok) {
        let msg = `Error ${res_save.status}`;
        let code;
        try {
            const body = await res_save.json();
            msg = body.message ?? body.error ?? msg;
            // "PLAN_LIMIT_REACHED" cuando el lote no entra en el cupo del plan.
            code = body.code;
        } catch (_) {}
        const err = new Error(msg);
        // El servidor respondió y rechazó el archivo (p. ej. planilla de otra entidad).
        // Distinto de un fallo de red, donde no hay mensaje que valga la pena mostrar.
        err.esRespuestaDelBackend = true;
        err.status = res_save.status;
        err.code = code;
        throw err;
    }
    return await res_save.json()
}
export async function importarTactos(establecimientoid,archivo){
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/import-tactos`
    
    const formData = new FormData();
    formData.append("file", archivo); // Debe coincidir con @RequestParam("file")
    let user = getUser();
    let token = user.token;
    

    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: formData,
        headers: {
            "Authorization": `Bearer ${user.token}`
        },
    })
    if (!res_save.ok) {
        let msg = `Error ${res_save.status}`;
        let code;
        try {
            const body = await res_save.json();
            msg = body.message ?? body.error ?? msg;
            // "PLAN_LIMIT_REACHED" cuando el lote no entra en el cupo del plan.
            code = body.code;
        } catch (_) {}
        const err = new Error(msg);
        // El servidor respondió y rechazó el archivo (p. ej. planilla de otra entidad).
        // Distinto de un fallo de red, donde no hay mensaje que valga la pena mostrar.
        err.esRespuestaDelBackend = true;
        err.status = res_save.status;
        err.code = code;
        throw err;
    }
    return await res_save.json()
}
export async function importarTratamientos(establecimientoid,archivo){
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/import-tratamientos`

    const formData = new FormData();
    formData.append("file", archivo); // Debe coincidir con @RequestParam("file")
    let user = getUser();
    let token = user.token;


    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: formData,
        headers: {
            "Authorization": `Bearer ${user.token}`
        },
    })
    if (!res_save.ok) {
        let msg = `Error ${res_save.status}`;
        let code;
        try {
            const body = await res_save.json();
            msg = body.message ?? body.error ?? msg;
            // "PLAN_LIMIT_REACHED" cuando el lote no entra en el cupo del plan.
            code = body.code;
        } catch (_) {}
        const err = new Error(msg);
        // El servidor respondió y rechazó el archivo (p. ej. planilla de otra entidad).
        // Distinto de un fallo de red, donde no hay mensaje que valga la pena mostrar.
        err.esRespuestaDelBackend = true;
        err.status = res_save.status;
        err.code = code;
        throw err;
    }
    return await res_save.json()
}
export async function importarNacimientos(establecimientoid,archivo){
    let ruta = `${RUTA_JAVA}${RUTA_ESTABLECIMIENTOS}/${establecimientoid}/import-nacimientos`
    
    const formData = new FormData();
    formData.append("file", archivo); // Debe coincidir con @RequestParam("file")
    let user = getUser();
    let token = user.token;
    

    let res_save = await handleAuthenticatedRequest(ruta, {
        method: "POST",
        body: formData,
        headers: {
            "Authorization": `Bearer ${user.token}`
        },
    })
    if (!res_save.ok) {
        let msg = `Error ${res_save.status}`;
        let code;
        try {
            const body = await res_save.json();
            msg = body.message ?? body.error ?? msg;
            // "PLAN_LIMIT_REACHED" cuando el lote no entra en el cupo del plan.
            code = body.code;
        } catch (_) {}
        const err = new Error(msg);
        // El servidor respondió y rechazó el archivo (p. ej. planilla de otra entidad).
        // Distinto de un fallo de red, donde no hay mensaje que valga la pena mostrar.
        err.esRespuestaDelBackend = true;
        err.status = res_save.status;
        err.code = code;
        throw err;
    }
    return await res_save.json()
}